import { Component, computed, input } from '@angular/core';
import { Message } from '../chat.model';
import { AgentMessageComponent } from './agent-message/agent-message.component';
import { UserMessageComponent } from './user-message/user-message.component';
import { sharesMinute } from './chat-history.util';

/** Renders the saved and streaming messages in a conversation. */
@Component({
  selector: 'app-chat-history',
  templateUrl: './chat-history.component.html',
  styleUrl: './chat-history.component.scss',
  standalone: true,
  imports: [AgentMessageComponent, UserMessageComponent],
})
export class ChatHistoryComponent {
  /** Inputs. */
  readonly messages = input.required<Message[]>();
  readonly currentAgentMsg = input<Message | null>();

  /** Indexes of the first user messages that display the shared timestamp of their minute group. */
  readonly timestampIndexes = computed(() => {
    const messages = this.messages();
    const indexes = new Set<number>();
    let groupHasUserMessage = false;
    messages.forEach((message, index) => {
      const previous = messages[index - 1];
      if (!previous || !sharesMinute(previous, message)) groupHasUserMessage = false;
      if (message.sender !== 'user') return;
      if (groupHasUserMessage) return;
      groupHasUserMessage = true;
      indexes.add(index);
    });
    return indexes;
  });
}
